export { DealFilterPipe } from "../pipes/deal-filter.pipe";
export { DealSortPipe } from "../pipes/deal-sort.pipe";
export { TeamFilterPipe } from "../pipes/team-filter.pipe";
export { VehicleNamePipe } from "../pipes/vehicle-name.pipe";
export { VehicleSortPipe } from "../pipes/vehicle-sort.pipe";
export { HowOldPipe } from "../pipes/how-old.pipe";
export { OrderByPipe } from "../pipes/order-by.pipe";
export { TruncatePipe } from "../pipes/truncate.pipe";